import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import HomePage from "../pages/HomePage";
import OrdersPage from "../pages/OrdersPage";
import OrderDetailPage from "../pages/OrderDetailPage";
import ProfilePage from "../pages/ProfilePage";
import AboutPage from "../pages/AboutPage";

interface Props {
  userEmail: string;
  displayName?: string;
  token?: string;
  onLogout?: () => void;
}

export default function Router({ userEmail, displayName, token, onLogout }: Props) {
  return (
    <BrowserRouter>
      <Layout userEmail={userEmail} displayName={displayName} onLogout={onLogout}>
        <Routes>
          <Route 
            path="/" 
            element={<HomePage userEmail={userEmail} displayName={displayName} token={token} />} 
          />
          <Route 
            path="/orders" 
            element={<OrdersPage userEmail={userEmail} displayName={displayName} />} 
          />
          <Route 
            path="/order/:orderId" 
            element={<OrderDetailPage userEmail={userEmail} displayName={displayName} />} 
          />
          <Route 
            path="/profile" 
            element={<ProfilePage userEmail={userEmail} displayName={displayName} />} 
          />
          <Route 
            path="/about" 
            element={<AboutPage />} 
          />
          
          {/* Redirect unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

